export default __webpack_public_path__ + "static/media/HeaderBG.a82d2963.jpg";